import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSEO } from "@/lib/seo";

const Block = ({ title, id, children }) => (
  <section id={id} className="mt-12 scroll-mt-28">
    <h2 className="font-display font-black text-3xl md:text-4xl uppercase text-ink leading-none">{title}</h2>
    <div className="mt-4 prose-editorial text-lg">{children}</div>
  </section>
);

export default function APropos() {
  useSEO({
    title: "À propos",
    description:
      "Contre-épreuve est un projet éditorial indépendant consacré aux faits, aux sources et aux récits publics. Découvrez le sens de son nom et son projet.",
  });
  return (
    <div className="mx-auto max-w-3xl px-5 md:px-8 py-14 md:py-20">
      <header>
        <p className="text-orange font-bold text-sm uppercase tracking-wide mb-4">À propos</p>
        <h1 className="font-display font-black text-5xl md:text-6xl uppercase leading-[0.92] text-ink">
          À propos de Contre-épreuve
        </h1>
      </header>

      <div className="mt-8 prose-editorial text-lg">
        <p>
          Contre-épreuve est un projet de média indépendant consacré aux faits, aux sources et aux
          récits publics. Il a vocation à publier des articles, des vérifications et des dossiers
          documentés portant notamment sur les organisations, les institutions, les transformations
          numériques et les questions contemporaines.
        </p>
      </div>

      <Block title="Le sens du nom" id="notre-demarche">
        <p>
          Une contre-épreuve est une seconde vérification. Elle consiste à reprendre une première
          représentation, à la confronter à d'autres éléments et à observer ce qui résiste, ce qui se
          nuance et ce qui se contredit.
        </p>
        <p>
          La contre-épreuve ne part pas du principe que le premier récit est faux. Elle cherche à
          déterminer sa portée, ses limites et les éléments qui permettent de le confirmer ou de le
          préciser.
        </p>
      </Block>

      <Block title="Le projet éditorial">
        <p>
          Contre-épreuve privilégiera des contenus accessibles, documentés et suffisamment précis pour
          permettre au lecteur de retrouver les principales sources utilisées.
        </p>
        <p>
          Le site accueillera progressivement plusieurs formats, depuis l'article court jusqu'au
          dossier approfondi.
        </p>
      </Block>

      <Block title="Contributions">
        <p>
          Le projet est ouvert aux propositions extérieures. Une connaissance précise d'un sujet,
          l'accès à des documents utiles ou la volonté de rendre une situation plus compréhensible
          peuvent constituer le point de départ d'une contribution.
        </p>
        <Link
          to="/contribuer"
          data-testid="apropos-contribuer-btn"
          className="not-prose mt-6 inline-flex items-center gap-2 bg-orange text-ink font-bold uppercase tracking-wide px-6 py-3.5 rounded-[10px] hover:bg-ink hover:text-orange transition-colors duration-200"
        >
          Proposer une contribution <ArrowRight size={17} />
        </Link>
      </Block>
    </div>
  );
}
